import React, { Component } from "react";
import Logout from "../../assets/logout.svg";
import Back from "../../assets/back.svg";
import Plus from "../../assets/plus.svg";
import EventActionButtons from "../../components/EventActionButtons";
import ListViewer from "../../components/ListViewer";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import { NumericFormat } from "react-number-format";
import CustomButton from "../../components/CustomButton";
import BootstrapSwitchButton from "bootstrap-switch-button-react";
import { Modal, Form } from "react-bootstrap";
import Cancel from "../../assets/cancel.svg";
import Tick from "../../assets/tick.svg";
import { WhisperSpinner } from "react-spinners-kit";
import { toast } from "react-toastify";
import Paginator from "../../components/Paginator";
import DatePicker, { DateObject } from "react-multi-date-picker";
import moment from "moment-jalaali";
import PieChart, {
  Connector,
  Font,
  SmallValuesGrouping,
  Size,
} from "devextreme-react/pie-chart";
import { Series, Label, Legend } from "devextreme-react/chart";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-multi-date-picker/styles/layouts/mobile.css";
import "react-multi-date-picker/styles/layouts/prime.css";
import "react-multi-date-picker/styles/colors/bluee.css";
import {
  BaseUrl,
  Authorization,
  isUser,
  LogoutFunction,
  ClubAuthorization,
} from "../../static.js";
import "../../App1.css";
import Tooltip from "@mui/material/Tooltip";

export default class Events extends Component {
  constructor(props) {
    super(props);
    this.formatCurrency = this.formatCurrency.bind(this);
    this.state = {
      gridLocaleText: {
        selectAll: "انتخاب همه",
        selectAllSearchResults: "انتخاب همه نتایج جستجو",
        searchOoo: "جستجو...",
        blanks: "خالی",
        noMatches: "پشدا نشد",
        filterOoo: "فیلتر...",
        equals: "مساوی",
        notEqual: "نا مساوی",
        lessThan: "کمتر از",
        greaterThan: "بیشتر از",
        lessThanOrEqual: "کوچکتر مساوی",
        greaterThanOrEqual: "بزرگتر مساوی",
        inRange: "در محدوده",
        inRangeStart: "به",
        inRangeEnd: "از",
        contains: "شامل",
        notContains: "شامل نباشد",
        startsWith: "شروع با",
        endsWith: "پایان با",
        andCondition: "و",
        orCondition: "یا",
        applyFilter: "تایید",
        resetFilter: "راه اندازی مجدد",
        clearFilter: "پاک کردن",
        cancelFilter: "انصراف",
        columns: "ستون ها",
        filters: "فیلترها",
        group: "گروه",
        loadingOoo: "لطفاً شکیبا باشید...",
        noRowsToShow: "هیچ موردی یافت نشد",
        enabled: "فعال",
        sum: "جمع",
        min: "کمترین",
        max: "بیشترین",
        none: "None",
        count: "تعداد",
        avg: "میانگین",
        filteredRows: "فیلتر شده",
        selectedRows: "انتخاب شده",
        totalRows: "جمع ردیف ها",
        totalAndFilteredRows: "ردیف ها",
        page: "صفحه",
        more: "بیشتر",
        to: "تا",
        of: "از",
        next: "بعدی",
        last: "آخرین",
        first: "اولین",
        previous: "قبلی",
      },
      rowData: [],
      columnDefs: [
        {
          headerName: "نام رويداد",
          field: "name",
          sortable: true,
          filter: false,
          resizable: false,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 0px 0px 1px",
            borderColor: "var(--gray1)",
          },
          lockPosition: true,
        },
        {
          headerName: "تاريخ شروع",
          field: "startDate",
          valueFormatter: this.formatDateTimeContent,
          sortable: true,
          filter: false,
          resizable: false,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 0px 0px 1px",
            borderColor: "var(--gray1)",
          },
          lockPosition: true,
        },
        {
          headerName: "تاريخ پايان",
          field: "endDate",
          valueFormatter: this.formatDateTimeContent,
          sortable: true,
          filter: false,
          resizable: false,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 0px 0px 1px",
            borderColor: "var(--gray1)",
          },
          lockPosition: true,
        },
        {
          headerName: "وضعيت",
          field: "status",
          sortable: true,
          filter: false,
          resizable: false,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 0px 0px 1px",
            borderColor: "var(--gray1)",
          },
          lockPosition: true,
        },
        {
          headerName: "اعتبار",
          field: "credit",
          cellRenderer: "formatCurrency",
          sortable: true,
          filter: false,
          resizable: false,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 0px 0px 1px",
            borderColor: "var(--gray1)",
          },
          lockPosition: true,
        },
        {
          headerName: "فعال / غیرفعال",
          field: "isActive",
          valueFormatter: this.formatActiveContent,
          sortable: true,
          filter: false,
          resizable: false,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 0px 0px 1px",
            borderColor: "var(--gray1)",
          },
          lockPosition: true,
        },
        {
          headerName: "حداقل خريد",
          field: "minPurchase",
          cellRenderer: "formatCurrency",
          sortable: true,
          filter: false,
          resizable: false,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 0px 0px 1px",
            borderColor: "var(--gray1)",
          },
          lockPosition: true,
        },
        {
          headerName: "متن الگوی پيام",
          field: "text",
          sortable: true,
          filter: false,
          resizable: false,
          wrapText: true,
          autoHeight: true,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 0px 0px 1px",
            borderColor: "var(--gray1)",
            maxWidth: "600px",
          },
          lockPosition: true,
        },
        {
          headerName: "تمام مشترکين",
          field: "applyToAllAccounts",
          valueFormatter: this.formatFiltersContent,
          sortable: true,
          filter: false,
          resizable: false,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 0px 0px 1px",
            borderColor: "var(--gray1)",
          },
          lockPosition: true,
        },
        {
          headerName: "فيلتر مشترکين",
          field: "accountPurchaseFilter",
          valueFormatter: this.formatFiltersContent,
          sortable: true,
          filter: false,
          resizable: false,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 0px 0px 1px",
            borderColor: "var(--gray1)",
          },
          lockPosition: true,
        },
        {
          headerName: "گروه‌های مشترکين",
          field: "accountGroupIdBatch",
          valueFormatter: this.formatFiltersContent,
          sortable: true,
          filter: false,
          resizable: false,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 0px 0px 1px",
            borderColor: "var(--gray1)",
          },
          lockPosition: true,
        },
        {
          headerName: "هزينه تخمينی",
          field: "roughlyCost",
          cellRenderer: "formatCurrency",
          sortable: true,
          filter: false,
          resizable: false,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 0px 0px 1px",
            borderColor: "var(--gray1)",
          },
          lockPosition: true,
        },
        {
          headerName: "تاریخ",
          field: "persianCreatedOn",
          sortable: true,
          filter: false,
          resizable: false,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 0px 0px 1px",
            borderColor: "var(--gray1)",
          },
          lockPosition: true,
        },
        {
          headerName: "عملیات",
          field: "id",
          cellRenderer: "fotmatEditCell",
          cellRendererParams: {
            editItem: this.editItem.bind(this),
            onActive: this.onActive.bind(this),
            onDelete: this.onDelete.bind(this),
            onReport: this.onReport.bind(this),
          },
          sortable: true,
          filter: false,
          resizable: false,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 0px 0px 1px",
            borderColor: "var(--gray1)",
            minWidth: "200px",
          },
          lockPosition: true,
        },
      ],
      frameworkComponents: {
        fotmatEditCell: EventActionButtons,
        formatCurrency: this.formatCurrency,
        formatDay: this.formatDay,
      },
      ModalShow: false,
      ModalShow2: false,
      modalType: 0,
      writingProgress: false,
      NameErrorText: "",
      NameValue: "",
      IsActive: true,
      MinPurchaseErrorText: "",
      MinPurchaseValue: "",
      CreditErrorText: "",
      CreditValue: "",
      InvoiceServiceType: [],
      AccountGroupIdBatch: [],
      ProductCategoryIdBatch: [],
      dataLoading: true,
      currentPage: 1,
      totalPages: 1,
      groupList: [],
      // productList: [],
      selectedGroupList: [],
      selectedMessageList: [],
      currentList: [],
      currentListType: "group",
      dateValue1: moment().format("jYYYY/jMM/jDD"),
      dateValue2: moment().format("jYYYY/jMM/jDD"),
      dateValue3: moment().format("jYYYY/jMM/jDD"),
      dateValue4: moment().format("jYYYY/jMM/jDD"),
      dateValue5: moment().format("jYYYY/jMM/jDD"),
      messageList: [],
      forAllUsers: false,
      forSomeUsers: false,
      fromPurchaseValue: "",
      fromPurchaseErrorText: "",
      toPurchaseValue: "",
      toPurchaseErrorText: "",
      roughlyCost: 0,
      roughlyCostPressed: false,
      totalAccountsCount: 0,
      ModalReport: false,
      modalReportLoading: false,
      chartData: [
        { title: "یک", value: 2 },
        { title: "دو", value: 5 },
      ],
      DeleteModalShow: false,
      deleteConfirmLoading: false,
      currentEventId: null,
      currentEventName: "",
      currentEventStartDate: "",
      currentEventEndDate: "",
      currentEventText: "",
      ActiveModalShow: false,
      reportTotalSMSCount: 0,
      reportSMSCost: 0,
      reportTotalInvoicePrice: 0,
      totalCopounCount: 0,
      totalCopounUsed: 0,
      smsReportPercent: 0,
      currentRestaurantId: null,
      priceUnit: "",
    };

    this.tableGrid = React.createRef();
    this.tableContainer = React.createRef();

    // this.datepicker1 = React.createRef();
    // this.datepicker2 = React.createRef();
    // this.datepicker3 = React.createRef();
    // this.datepicker4 = React.createRef();
    this.chartContainer = React.createRef();
    this.chartRef = React.createRef();

    this.GetRuleEvents = this.GetRuleEvents.bind(this);
    this.textHandleChange = this.textHandleChange.bind(this);
    this.resetModalValues = this.resetModalValues.bind(this);
    this.creditValue = this.creditValue.bind(this);
    this.GetEventReport = this.GetEventReport.bind(this);

    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }

  onReport(id) {
    this.state.rowData.forEach((element) => {
      if (element.id === id) {
        this.setState({
          currentEventName: element.name,
          currentEventStartDate: moment(element.startDate).format(
            "jYYYY/jMM/jDD"
          ),
          currentEventEndDate: moment(element.endDate).format("jYYYY/jMM/jDD"),
          currentEventText: element.text,
        });
      }
    });
    this.setState({ ModalReport: true }, () => {
      this.GetEventReport(id);
    });
  }

  onConfirmFinalActive() {
    let data = isUser
      ? {
          businessCode: this.props.match.params.id,
        }
      : {};
    data = Object.assign(data, ClubAuthorization());
    let jsonString = "SepandPlus " + btoa(JSON.stringify(data));

    fetch(
      "https://94.101.187.196/api/RuleEvent/FinalActivateEvent?restaurantId=" +
        this.props.match.params.id +
        "&eventId=" +
        this.state.currentEventId +
        "&startSendindDate=" +
        moment(this.state.dateValue5, "jYYYY/jMM/jDD").format("YYYY-MM-DD"),
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: jsonString,
        },
        // body: JSON.stringify(data),
      }
    )
      .then((res) => res.json())
      .then((result) => {
        console.log("result: ", result);

        if (!result.isSuccessfull) {
          toast.error(result.errorMessage, {
            position: toast.POSITION.BOTTOM_RIGHT,
            hideProgressBar: true,
            autoClose: 8000,
            toastClassName: "toast",
          });
          return;
        }

        // toast.success(
        //   this.state.modalType === 0
        //     ? "رویداد با موفقیت ایجاد شد"
        //     : "رویداد با موفقیت ویرایش شد",
        //   {
        //     position: toast.POSITION.BOTTOM_RIGHT,
        //     hideProgressBar: true,
        //     autoClose: 8000,
        //     toastClassName: "toast",
        //   }
        // );

        this.setState({ ActiveModalShow: false });

        this.GetRuleEvents(this.state.currentPage, false);
      })
      .catch((err) => {
        console.log(err);
        this.setState({ listLoading: false });
      });
  }

  onActive(id) {
    this.setState({ currentEventId: id, ActiveModalShow: true });
  }

  onConfirmDelete() {
    let data = isUser
      ? {
          businessCode: this.props.match.params.id,
        }
      : {};
    data = Object.assign(data, ClubAuthorization());
    let jsonString = "SepandPlus " + btoa(JSON.stringify(data));

    this.setState({ deleteConfirmLoading: true });
    fetch(
      "https://94.101.187.196/api/RuleEvent/DeleteRuleEvent?restaurantId=" +
        this.props.match.params.id +
        "&eventId=" +
        this.state.currentEventId,
      {
        method: "POST",
        headers: { Authorization: jsonString },
      }
    )
      .then((res) => res.json())
      .then((result) => {
        console.log("result: ", result);

        if (!result.isSuccessfull) {
          toast.error(result.errorMessage, {
            position: toast.POSITION.BOTTOM_RIGHT,
            hideProgressBar: true,
            autoClose: 8000,
            toastClassName: "toast",
          });
          this.setState({ deleteConfirmLoading: false });
          return;
        }

        toast.success("رویداد با موفقیت حذف شد", {
          position: toast.POSITION.BOTTOM_RIGHT,
          hideProgressBar: true,
          autoClose: 8000,
          toastClassName: "toast",
        });

        this.setState({ deleteConfirmLoading: false, DeleteModalShow: false });

        this.GetRuleEvents(this.state.currentPage, false);
      })
      .catch((err) => {
        console.log(err);
        this.setState({ deleteConfirmLoading: false });
      });
  }

  onDelete(id) {
    this.setState({ currentEventId: id, DeleteModalShow: true });
  }

  formatDateTimeContent(params) {
    return moment(params.value).format("jYYYY/jMM/jDD");
  }

  formatDay(params) {
    try {
      if (
        params.value === "null" ||
        params.value === "" ||
        params.value === 0 ||
        params.value === null
      )
        return "-";
      return (
        <NumericFormat
          value={params.value}
          displayType={"text"}
          thousandSeparator={false}
          suffix={" روز"}
        />
      );
    } catch (error) {
      return "-";
    }
  }

  formatServices(params) {
    let text = "";
    params.value.forEach((element) => {
      if (element === 0) {
        if (text === "") text = "داخلی";
        else text += " ، داخلی";
      } else if (element === 1) {
        if (text === "") text = "بسته‌بندی";
        else text += " ، بسته‌بندی";
      } else if (element === 2) {
        if (text === "") text = "ارسال";
        else text += " ، ارسال";
      }
    });
    if (text === "") text = "هیچکدام";
    return text;
  }

  formatCurrency(params) {
    try {
      if (
        params.value === "null" ||
        params.value === "" ||
        params.value === 0 ||
        params.value === null
      )
        return "-";
      // const aa=(params.value).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      return (
        <NumericFormat
          value={params.value}
          displayType={"text"}
          thousandSeparator={true}
          suffix={" " + this.state.priceUnit}
        />
      );
      //return <div style={{display:'flex',flexDirection:'row'}}><div>ریال&nbsp;</div><NumericFormat style={{fontFamily:'SFUIDisplayBold'}} value={params.value} displayType={'text'} thousandSeparator={true}/></div>
    } catch (error) {
      return "-";
    }
  }

  formatActiveContent(params) {
    if (params.value) return "فعال";
    else return "غیرفعال";
  }

  formatFiltersContent(params) {
    if (params.value) return "✔";
    else return "✖";
  }
  fotmatEditCell(params) {
    return;
  }

  updateWindowDimensions() {
    try {
      if (this.state.ModalReport) {
        window.setTimeout(() => {
          let h = this.chartContainer.current.getBoundingClientRect().height;
          let w = this.chartContainer.current.getBoundingClientRect().width;
          this.setState(
            {
              chartContainerWidth: w,
              chartContainerHeight: h,
              thisWidth: window.innerWidth,
              thisHeight: window.innerHeight,
            },
            () => {
              if (this.chartRef.current)
                this.chartRef.current.instance.render();
            }
          );
        }, 100);
      }
    } catch (error) {}
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWindowDimensions);
  }

  getBusinessInfo() {
    let data = {
      businessCode: this.props.match.params.id,
    };
    data = Object.assign(data, Authorization());

    fetch(BaseUrl + "findBusinessWithCode", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => {
        console.log(result);
        if (result.status === 200) {
          this.setState(
            {
              currentRestaurantId: result.result[0].id,
              priceUnit: result.result[0].rtlPriceTitle,
            },
            () => {
              this.GetRuleEvents(1, true);
            }
          );
        } else if (result.status === 401) {
          LogoutFunction();
        }
        // console.log("findBusinessWithCode:", result);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  componentDidMount() {
    window.addEventListener("resize", this.updateWindowDimensions);
    this.updateWindowDimensions();
    this.getBusinessInfo();
  }

  GetEventReport(eventId) {
    this.setState({ modalReportLoading: true });

    let data = isUser
      ? {
          businessCode: this.props.match.params.id,
        }
      : {};
    data = Object.assign(data, ClubAuthorization());
    let jsonString = "SepandPlus " + btoa(JSON.stringify(data));

    fetch(
      "https://94.101.187.196/api/RuleEvent/GetEventReport?restaurantId=" +
        this.state.currentRestaurantId +
        "&eventId=" +
        eventId,
      {
        method: "GET",
        headers: { Authorization: jsonString },
      }
    )
      .then((res) => {
        if (res.status === 401) {
          LogoutFunction();
        } else {
          return res.json();
        }
      })
      .then((result) => {
        console.log(result);
        if (!result.isSuccessfull) {
          toast.error(result.errorMessage, {
            position: toast.POSITION.BOTTOM_RIGHT,
            hideProgressBar: true,
            autoClose: 8000,
            toastClassName: "toast",
          });
          this.setState({ modalReportLoading: false, ModalReport: false });
          return;
        }

        let totalCopounCount = result.results[0].totalCopounCount;
        let totalCopounUsed = result.results[0].totalCopounUsed;

        let percent = 0;
        if (totalCopounUsed > 0) {
          percent = (100 / (totalCopounCount / totalCopounUsed)).toFixed(2);
        }

        this.setState({
          reportTotalSMSCount: result.results[0].totalSMSCount,
          reportTotalInvoicePrice: result.results[0].totalInvoicePrice,
          reportSMSCost: result.results[0].smsCost,
          totalCopounCount: result.results[0].totalCopounCount,
          totalCopounUsed: result.results[0].totalCopounUsed,
          smsReportPercent: percent,
          // chartData:[{title:'تمام کد های ارسالی',value:result.results[0].totalCopounCount},{title:'کد های استفاده شده',value:result.results[0].totalCopounUsed}],
          modalReportLoading: false,
        });
      })
      .catch((err) => {
        console.log(err);
        this.setState({ modalReportLoading: false });
      });
  }

  GetRuleEvents(page, firstLoad) {
    this.setState({ dataLoading: true });

    let data = isUser
      ? {
          businessCode: this.props.match.params.id,
        }
      : {};
    data = Object.assign(data, ClubAuthorization());
    let jsonString = "SepandPlus " + btoa(JSON.stringify(data));

    fetch(
      "https://94.101.187.196/api/RuleEvent/GetRuleEvents?restaurantId=" +
        this.state.currentRestaurantId +
        "&page=" +
        page,
      {
        method: "GET",
        headers: { Authorization: jsonString },
      }
    )
      .then((res) => {
        if (res.status === 401) {
          LogoutFunction();
        } else {
          return res.json();
        }
      })
      .then((result) => {
        console.log("GetRuleEvents:", result);
        if (!result.isSuccessfull) {
          toast.error(result.errorMessage, {
            position: toast.POSITION.BOTTOM_RIGHT,
            hideProgressBar: true,
            autoClose: 8000,
            toastClassName: "toast",
          });
        }

        this.setState(
          {
            // dataLoading: false,
            rowData: result.results ? result.results[0].pageData : [],
            currentPage: result.results ? result.results[0].currentPage : 1,
            totalPages: result.results ? result.results[0].totalPages : 1,
          },
          () => {
            if (firstLoad) this.GetAccountGroups();
          }
        );
      })
      .catch((err) => {
        console.log(err);
        this.setState({ dataLoading: false });
      });
  }

  onFirstPageClick() {
    this.GetRuleEvents(1, false);
  }

  onPreviousPageClick() {
    this.GetRuleEvents(this.state.currentPage - 1, false);
  }

  onNextPageClick() {
    this.GetRuleEvents(this.state.currentPage + 1, false);
  }

  onLastPageClick() {
    this.GetRuleEvents(this.state.totalPages, false);
  }

  onBack() {
    this.props.history.push(
      "/Restaurants/" + this.props.match.params.id + "/Club"
    );
  }

  onLogout() {
    LogoutFunction();
  }

  onFirstDataRendered(params) {
    try {
      params.api.sizeColumnsToFit();
      window.setTimeout(() => {
        const colIds = params.columnApi.getAllColumns().map((c) => c.colId);
        // colIds.pop();
        params.columnApi.autoSizeColumns(colIds, false);

        let cols = this.tableGrid.current.columnApi.getColumnState();
        let width = 0;
        cols.forEach((element) => {
          width += element.width;
        });

        if (
          width <
          this.tableContainer.current.getBoundingClientRect().width - 10
        ) {
          let def =
            this.tableContainer.current.getBoundingClientRect().width -
            10 -
            width;
          if (def > cols.length) {
            let newwidth = def / cols.length;
            cols.forEach((element) => {
              params.columnApi.setColumnWidth(
                element.colId,
                element.width + newwidth
              );
            });
          } else {
            params.columnApi.setColumnWidth(cols[0].colId, cols[0].width + def);
          }
        }
      }, 50);
    } catch (error) {}
  }

  resetModalValues(id) {
    this.setState(
      {
        writingProgress: false,
        NameErrorText: "",
        NameValue: "",
        IsActive: true,
        MinPurchaseErrorText: "",
        MinPurchaseValue: "",
        CreditErrorText: "",
        CreditValue: "",
        // groupList: [],
        // currentList: [],
        currentListType: "group",
        // messageList: [],
        forAllUsers: false,
        forSomeUsers: false,
        fromPurchaseValue: "",
        fromPurchaseErrorText: "",
        toPurchaseValue: "",
        toPurchaseErrorText: "",
        roughlyCost: 0,
        roughlyCostPressed: false,
        totalAccountsCount: 0,
      },
      () => {
        if (id !== 0) {
          this.state.rowData.forEach((element) => {
            if (element.id === id) {
              if (element.accountPurchaseFilter) {
                let accountPurchaseFilter =
                  element.accountPurchaseFilter.split(",");
                this.setState({
                  dateValue3: moment(accountPurchaseFilter[0]).format(
                    "jYYYY/jMM/jDD"
                  ),
                  dateValue4: moment(accountPurchaseFilter[1]).format(
                    "jYYYY/jMM/jDD"
                  ),
                  fromPurchaseValue: accountPurchaseFilter[2],
                  toPurchaseValue: accountPurchaseFilter[3],
                });
              }

              this.setState({
                NameValue: element.name,
                IsActive: element.isActive,
                // groupList: element.accountGroupIdBatch,
                productList: element.productCategoryIdBatch,
                MinPurchaseValue: element.minPurchase,
                CreditValue: element.credit,
                dateValue1: moment(element.startDate).format("jYYYY/jMM/jDD"),
                dateValue2: moment(element.endDate).format("jYYYY/jMM/jDD"),
                // messageList: [{ id: 0, text: element.text }],
                forAllUsers: element.applyToAllAccounts,
                forSomeUsers: element.accountPurchaseFilter ? true : false,
                // groupList: element.accountGroupIdBatch.split(","),
                roughlyCost: element.roughlyCost,
                roughlyCostPressed: true,
              });
            }
          });
        }
      }
    );
  }

  onAddNewButton() {
    this.resetModalValues(0);
    this.setState({ ModalShow: true, modalType: 0 });
  }

  editItem(e) {
    this.resetModalValues(e);
    this.setState({ ModalShow: true, modalType: e });
  }

  hideModal() {
    this.setState({ ModalShow: false });
  }

  hideModal2() {
    this.setState({ ModalShow2: false });
  }

  textHandleChange(e) {
    this.setState({ [e.target.name]: e.target.value });
  }

  onConfirm() {
    if (!this.state.NameValue) {
      this.setState({ NameErrorText: "نام رویداد نمی‌تواند خالی باشد" }, () => {
        toast.error(this.state.NameErrorText, {
          position: toast.POSITION.BOTTOM_RIGHT,
          hideProgressBar: true,
          autoClose: 8000,
          toastClassName: "toast",
        });
      });
      return;
    } else {
      this.setState({ NameErrorText: "" });
    }

    if (!this.state.CreditValue) {
      this.setState(
        { CreditErrorText: "میزان اعتبار نمی‌تواند خالی باشد" },
        () => {
          toast.error(this.state.CreditErrorText, {
            position: toast.POSITION.BOTTOM_RIGHT,
            hideProgressBar: true,
            autoClose: 8000,
            toastClassName: "toast",
          });
        }
      );
      return;
    } else {
      this.setState({ CreditErrorText: "" });
    }

    if (!this.state.MinPurchaseValue) {
      this.setState(
        { MinPurchaseErrorText: "حداقل خرید نمی‌تواند خالی باشد" },
        () => {
          toast.error(this.state.MinPurchaseErrorText, {
            position: toast.POSITION.BOTTOM_RIGHT,
            hideProgressBar: true,
            autoClose: 8000,
            toastClassName: "toast",
          });
        }
      );
      return;
    } else {
      this.setState({ MinPurchaseErrorText: "" });
    }

    let groupId = "";
    let fromDate = "";
    let toDate = "";
    let fromPurchase = "";
    let toPurchase = "";
    let accountPurchaseFilter = "";

    if (!this.state.forAllUsers) {
      if (!this.state.forSomeUsers) {
        if (this.state.selectedGroupList.length < 1) {
          toast.error("لطفاً گروه مشترکین را انتخاب کنید", {
            position: toast.POSITION.BOTTOM_RIGHT,
            hideProgressBar: true,
            autoClose: 8000,
            toastClassName: "toast",
          });
          return;
        } else {
          this.state.selectedGroupList.forEach((element) => {
            if (groupId === "") groupId = element;
            else groupId += "," + element;
          });
        }
      } else {
        if (!this.state.fromPurchaseValue) {
          toast.error("حداقل مبلغ خرید مشترک را مشخص کنید", {
            position: toast.POSITION.BOTTOM_RIGHT,
            hideProgressBar: true,
            autoClose: 8000,
            toastClassName: "toast",
          });
          return;
        }

        if (!this.state.toPurchaseValue) {
          toast.error("حداکثر مبلغ خرید مشترک را مشخص کنید", {
            position: toast.POSITION.BOTTOM_RIGHT,
            hideProgressBar: true,
            autoClose: 8000,
            toastClassName: "toast",
          });
          return;
        }

        fromDate = moment(this.state.dateValue3, "jYYYY/jMM/jDD").format(
          "YYYY-MM-DD"
        );
        toDate = moment(this.state.dateValue4, "jYYYY/jMM/jDD").format(
          "YYYY-MM-DD"
        );
        fromPurchase = this.state.fromPurchaseValue;
        toPurchase = this.state.toPurchaseValue;

        accountPurchaseFilter =
          fromDate +
          " 00:00:00," +
          toDate +
          " 23:59:59," +
          fromPurchase +
          "," +
          toPurchase;
      }
    }

    if (this.state.messageList.length < 1) {
      toast.error("لطفاً الگوی پیام مورد نظر خود را مشخص کنید", {
        position: toast.POSITION.BOTTOM_RIGHT,
        hideProgressBar: true,
        autoClose: 8000,
        toastClassName: "toast",
      });
      return;
    }

    if (this.state.messageList[0].text.trim() === "") {
      toast.error("الگوی پیام انتخاب شده نامعتبر است", {
        position: toast.POSITION.BOTTOM_RIGHT,
        hideProgressBar: true,
        autoClose: 8000,
        toastClassName: "toast",
      });
      return;
    }

    if (!this.state.roughlyCostPressed) {
      toast.error("لطفاً هزینه تقریبی را محاسبه کنید", {
        position: toast.POSITION.BOTTOM_RIGHT,
        hideProgressBar: true,
        autoClose: 8000,
        toastClassName: "toast",
      });
      return;
    }

    if (this.state.roughlyCost === 0) {
      toast.error("این رویداد شامل هیچ مخاطبی نمی‌شود", {
        position: toast.POSITION.BOTTOM_RIGHT,
        hideProgressBar: true,
        autoClose: 8000,
        toastClassName: "toast",
      });
      return;
    }

    let apiname = "";
    if (this.state.modalType === 0) {
      apiname = "AddNewRuleEvent";
    } else {
      apiname = "EditRuleEvent";
    }

    let data = {
      restaurantId: this.state.currentRestaurantId,
      id: this.state.modalType,
      name: this.state.NameValue,
      startDate:
        moment(this.state.dateValue1, "jYYYY/jMM/jDD").format("YYYY-MM-DD") +
        " 00:00:00",
      endDate:
        moment(this.state.dateValue2, "jYYYY/jMM/jDD").format("YYYY-MM-DD") +
        " 23:59:59",
      credit: Number(this.state.CreditValue),
      isActive: this.state.IsActive,
      minPurchase: Number(this.state.MinPurchaseValue),
      sMSTemplateId: this.state.messageList[0].id,
      applyToAllAccounts: this.state.forAllUsers,
      accountPurchaseFilter: accountPurchaseFilter,
      accountGroupIdBatch: groupId,
      roughlyCost: Number(this.state.roughlyCost),
    };

    let data1 = isUser
      ? {
          businessCode: this.props.match.params.id,
        }
      : {};
    data1 = Object.assign(data1, ClubAuthorization());
    let jsonString = "SepandPlus " + btoa(JSON.stringify(data1));

    fetch("https://94.101.187.196/api/RuleEvent/" + apiname, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: jsonString,
      },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => {
        console.log("result: ", result);

        if (!result.isSuccessfull) {
          toast.error(result.errorMessage, {
            position: toast.POSITION.BOTTOM_RIGHT,
            hideProgressBar: true,
            autoClose: 8000,
            toastClassName: "toast",
          });
          return;
        }

        toast.success(
          this.state.modalType === 0
            ? "رویداد با موفقیت ایجاد شد"
            : "رویداد با موفقیت ویرایش شد",
          {
            position: toast.POSITION.BOTTOM_RIGHT,
            hideProgressBar: true,
            autoClose: 8000,
            toastClassName: "toast",
          }
        );

        this.setState({ listLoading: false, ModalShow: false });

        this.GetRuleEvents(this.state.currentPage, false);
      })
      .catch((err) => {
        console.log(err);
        this.setState({ listLoading: false });
      });
  }

  GetAccountGroups() {
    let data = isUser
      ? {
          businessCode: this.props.match.params.id,
        }
      : {};
    data = Object.assign(data, ClubAuthorization());
    let jsonString = "SepandPlus " + btoa(JSON.stringify(data));

    fetch(
      "https://94.101.187.196/api/AccountGroup/GetAccountGroups?restaurantId=" +
        this.state.currentRestaurantId +
        "&page=0",
      {
        method: "GET",
        headers: { Authorization: jsonString },
      }
    )
      .then((res) => {
        if (res.status === 401) {
          LogoutFunction();
        } else {
          return res.json();
        }
      })
      .then((result) => {
        console.log("GetAccountGroups: ", result);

        // if (!result.isSuccessfull) {
        //   toast.error(result.errorMessage, {
        //     position: toast.POSITION.BOTTOM_RIGHT,
        //     hideProgressBar: true,
        //     autoClose: 8000,
        //     toastClassName: "toast",
        //   });
        // }

        this.setState(
          {
            groupList: result.results ? result.results[0].items : [],
          },
          () => {
            this.GetSMSTemplates();
          }
        );
      })
      .catch((err) => {
        console.log(err);
        // this.setState({ listLoading: false });
      });
  }

  onCustomerGroupsClick() {
    this.setState({
      ModalShow2: true,
      // listLoading: true,
      currentListType: "group",
    });
  }

  // onProductCategory() {
  //   this.setState({
  //     ModalShow2: true,
  //     listLoading: true,
  //     currentListType: "product",
  //   });

  //   fetch(
  //     "https://94.101.187.196/api/ProductCategory/GetProductCategories?restaurantId=" +
  //       this.props.match.params.id,
  //     {
  //       method: "GET",
  //       headers: { Authorization: "Bearer " + localStorage.getItem("token") },
  //     }
  //   )
  //     .then((res) => {
  //       if (res.status === 401) {
  //       } else {
  //         return res.json();
  //       }
  //     })
  //     .then((result) => {
  //       console.log(result);
  //       // if (result.isSuccessfull){

  //       // }else {
  //       //     this.props.history.push('/Restaurants');
  //       // }

  //       if (!result.isSuccessfull) {
  //         toast.error(result.errorMessage, {
  //           position: toast.POSITION.BOTTOM_RIGHT,
  //           hideProgressBar: true,
  //           autoClose: 8000,
  //           toastClassName: "toast",
  //         });
  //       }

  //       this.setState({ listLoading: false, currentList: result.results });
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //       this.setState({ listLoading: false });
  //     });
  // }

  onConfirmGroups(list) {
    this.setState({
      selectedGroupList: list,
      ModalShow2: false,
      roughlyCost: 0,
      roughlyCostPressed: false,
      totalAccountsCount: 0,
    });
  }

  // onConfirmCategory(list) {
  //   this.setState({ groupList: list, ModalShow2: false });
  // }

  onConfirmMessage(list) {
    this.setState({
      messageList: list,
      ModalShow2: false,
      roughlyCost: 0,
      roughlyCostPressed: false,
      totalAccountsCount: 0,
    });
  }

  dateChange1(dateValue) {
    let value = this.fixNumber(new DateObject(dateValue).format("YYYY/MM/DD"));
    this.setState({ dateValue1: value });

    if (moment(value) > moment(this.state.dateValue2)) {
      this.setState({ dateValue2: value });
    }
  }

  dateChange2(dateValue) {
    let value = this.fixNumber(new DateObject(dateValue).format("YYYY/MM/DD"));
    this.setState({ dateValue2: value });
  }

  dateChange3(dateValue) {
    let value = this.fixNumber(new DateObject(dateValue).format("YYYY/MM/DD"));
    this.setState({ dateValue3: value });

    if (moment(value) > moment(this.state.dateValue4)) {
      this.setState({ dateValue4: value });
    }
  }

  dateChange4(dateValue) {
    let value = this.fixNumber(new DateObject(dateValue).format("YYYY/MM/DD"));
    this.setState({ dateValue4: value });
  }

  dateChange5(dateValue) {
    let value = this.fixNumber(new DateObject(dateValue).format("YYYY/MM/DD"));
    this.setState({ dateValue5: value });
  }

  fixNumber(str) {
    var persianNumbers = [
        /۰/g,
        /۱/g,
        /۲/g,
        /۳/g,
        /۴/g,
        /۵/g,
        /۶/g,
        /۷/g,
        /۸/g,
        /۹/g,
      ],
      arabicNumbers = [
        /٠/g,
        /١/g,
        /٢/g,
        /٣/g,
        /٤/g,
        /٥/g,
        /٦/g,
        /٧/g,
        /٨/g,
        /٩/g,
      ];
    if (typeof str === "string") {
      for (var i = 0; i < 10; i++) {
        str = str.replace(persianNumbers[i], i).replace(arabicNumbers[i], i);
      }
    }
    return str;
  }

  GetSMSTemplates() {
    let data = isUser
      ? {
          businessCode: this.props.match.params.id,
        }
      : {};
    data = Object.assign(data, ClubAuthorization());
    let jsonString = "SepandPlus " + btoa(JSON.stringify(data));

    fetch(
      "https://94.101.187.196/api/SMSTemplate/GetSMSTemplates?restaurantId=" +
        this.state.currentRestaurantId +
        "&smsTypeId=1&page=0",
      {
        method: "GET",
        headers: { Authorization: jsonString },
      }
    )
      .then((res) => {
        if (res.status === 401) {
          LogoutFunction();
        } else {
          return res.json();
        }
      })
      .then((result) => {
        console.log("GetSMSTemplates: ", result);
        // if (!result.isSuccessfull) {
        //   toast.error(result.errorMessage, {
        //     position: toast.POSITION.BOTTOM_RIGHT,
        //     hideProgressBar: true,
        //     autoClose: 8000,
        //     toastClassName: "toast",
        //   });
        // }

        this.setState({
          dataLoading: false,
          messageList: result.results ? result.results[0].pageData : [],
        });
      })
      .catch((err) => {
        console.log(err);
        // this.setState({ listLoading: false });
      });
  }

  onMessagePatternClick() {
    this.setState({
      ModalShow2: true,
      // listLoading: true,
      currentListType: "message",
    });
  }

  onCalCostClick() {
    let groupId = "";
    let fromDate = "";
    let toDate = "";
    let fromPurchase = "";
    let toPurchase = "";
    if (!this.state.forAllUsers) {
      if (!this.state.forSomeUsers) {
        if (this.state.selectedGroupList.length < 1) {
          toast.error("لطفاً گروه مشترکین را انتخاب کنید", {
            position: toast.POSITION.BOTTOM_RIGHT,
            hideProgressBar: true,
            autoClose: 8000,
            toastClassName: "toast",
          });
          return;
        } else {
          this.state.selectedGroupList.forEach((element) => {
            if (groupId === "") groupId = element;
            else groupId += "," + element;
          });
        }
      } else {
        if (!this.state.fromPurchaseValue) {
          toast.error("حداقل مبلغ خرید مشترک را مشخص کنید", {
            position: toast.POSITION.BOTTOM_RIGHT,
            hideProgressBar: true,
            autoClose: 8000,
            toastClassName: "toast",
          });
          return;
        }

        if (!this.state.toPurchaseValue) {
          toast.error("حداکثر مبلغ خرید مشترک را مشخص کنید", {
            position: toast.POSITION.BOTTOM_RIGHT,
            hideProgressBar: true,
            autoClose: 8000,
            toastClassName: "toast",
          });
          return;
        }

        fromDate =
          moment(this.state.dateValue3, "jYYYY/jMM/jDD").format("YYYY-MM-DD") +
          " 00:00:00";
        toDate =
          moment(this.state.dateValue4, "jYYYY/jMM/jDD").format("YYYY-MM-DD") +
          " 23:59:59";
        fromPurchase = this.state.fromPurchaseValue;
        toPurchase = this.state.toPurchaseValue;
      }
    }

    if (this.state.messageList.length < 1) {
      toast.error("لطفاً الگوی پیام مورد نظر خود را مشخص کنید", {
        position: toast.POSITION.BOTTOM_RIGHT,
        hideProgressBar: true,
        autoClose: 8000,
        toastClassName: "toast",
      });
      return;
    }

    if (this.state.messageList[0].text.trim() === "") {
      toast.error("الگوی پیام انتخاب شده نامعتبر است", {
        position: toast.POSITION.BOTTOM_RIGHT,
        hideProgressBar: true,
        autoClose: 8000,
        toastClassName: "toast",
      });
      return;
    }

    let data = isUser
      ? {
          businessCode: this.props.match.params.id,
        }
      : {};
    data = Object.assign(data, ClubAuthorization());
    let jsonString = "SepandPlus " + btoa(JSON.stringify(data));

    fetch(
      "https://94.101.187.196/api/RuleEvent/CalculatedEventRoughlyCost?restaurantId=" +
        this.state.currentRestaurantId +
        "&applyToAllAccounts=" +
        this.state.forAllUsers +
        "&accountGroupIdBatch=" +
        groupId +
        "&fromDate=" +
        fromDate +
        "&toDate=" +
        toDate +
        "&fromPurchase=" +
        fromPurchase +
        "&toPurchase=" +
        toPurchase +
        "&text=" +
        (this.state.messageList.length > 0
          ? this.state.messageList[0].text
          : ""),
      {
        method: "GET",
        headers: { Authorization: jsonString },
      }
    )
      .then((res) => {
        if (res.status === 401) {
          LogoutFunction();
        } else {
          return res.json();
        }
      })
      .then((result) => {
        if (!result.isSuccessfull) {
          toast.error(result.errorMessage, {
            position: toast.POSITION.BOTTOM_RIGHT,
            hideProgressBar: true,
            autoClose: 8000,
            toastClassName: "toast",
          });
        }

        this.setState({
          totalAccountsCount: result.results[0].totalAccountsCount,
          roughlyCost: result.results[0].roughlyCost,
          roughlyCostPressed: true,
        });
      })
      .catch((err) => {
        console.log(err);
        this.setState({ listLoading: false });
      });
  }

  creditValue(params) {
    let result =
      params.value.toString() +
      " عدد (" +
      params.point.data.amount
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",") +
      " )" +
      this.state.priceUnit +
      " (" +
      params.percentText.toString() +
      ")";
    return result;
  }

  render() {
    return (
      <div className="Login">
        <div className="header">
          <div
            onClick={this.onBack.bind(this)}
            className="linkStyle backButton"
          >
            <img
              src={Back}
              alt=""
              className="backButtonIcon"
              style={{ transform: "rotate(180deg)" }}
            />
            بازگشت
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              height: "fit-content",
              alignItems: "center",
            }}
          >
            <Tooltip title="خروج">
              <div
                onClick={this.onLogout.bind(this)}
                className="linkStyle backButton"
              >
                <img src={Logout} alt="" className="backButtonIcon" />
              </div>
            </Tooltip>
          </div>
        </div>
        <div className="LoginContent">
          <div className="RestaurantsListTitle">رویدادها</div>
          <div className="RestaurantsListSubTitle">ایجاد و ویرایش رویدادها</div>
        </div>
        <div className="pageContents" ref={this.tableContainer}>
          <ul>
            <li>
              تاييد الگوی پيام توسط سپند، بين يک الی چند روز کاری زمان خواهد
              برد.
            </li>
            <li>
              بعد از فعال سازی نهايی رويداد، امکان ويرايش و يا حذف وجود ندارد و
              کد تخفيف ها ارسال خواهند شد.
            </li>
            <li>
              ارسال کد تخفيف، با توجه به تعداد مشترک و شرايط سرور، بين 1 الی 10
              ساعت زمان می برد. بديهی است با توجه به تاريخ شروع رويداد مربوطه،
              تاريخ ارسال پيامک ها را در زمان مناسب انتخاب نماييد. (ساعت ارسال
              پيامک ها از 10 صبح الی 10 شب می باشد)
            </li>
            <li>
              با توجه به تخمين هزينه رويداد، بايد پنل اس ام اس رستوران به اندازه
              ی کافی شارژ داشته باشد و چک شود، در غير اينصورت تا زمان شارژ مجدد،
              پيام ها ارسال نخواهند شد.
            </li>
          </ul>
          {!this.state.dataLoading && (
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "flex-start",
                alignItems: "center",
                width: "fit-content",
              }}
            >
              <CustomButton
                title="رویداد جدید"
                imgHeight={20}
                imgWidth={25}
                flexDirection="row-reverse"
                minHeight="35px"
                img={Plus}
                onClick={this.onAddNewButton.bind(this)}
              />
            </div>
          )}

          {!this.state.dataLoading && (
            <div
              className="tableContainer ag-theme-alpine"
              style={{ minHeight: "500px" }}
            >
              <AgGridReact
                enableRtl={true}
                autoHeight={true}
                animateRows={true}
                enableBrowserTooltips={true}
                tooltipMouseTrack={true}
                suppressSizeToFit={false}
                columnDefs={this.state.columnDefs}
                localeText={this.state.gridLocaleText}
                rowData={this.state.rowData}
                suppressDragLeaveHidesColumns={true}
                suppressMovable={true}
                skipHeaderOnAutoSize={false}
                // onGridReady={this.onGridReady.bind(this)}
                onFirstDataRendered={this.onFirstDataRendered.bind(this)}
                rowHeight={window.innerWidth <= 587 ? 40 : 50}
                headerHeight={window.innerWidth <= 587 ? 40 : 50}
                frameworkComponents={this.state.frameworkComponents}
                // onRowClicked={this.onGridRowClicked.bind(this)}
                // getRowStyle ={function(params){ return { borderWidth:'0px' }}}
                ref={this.tableGrid}
                enableCellTextSelection={true}
                ensureDomOrder={true}
              ></AgGridReact>
            </div>
          )}
          {!this.state.dataLoading && (
            <div
              style={{
                width: "100%",
                marginTop: "15px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "column",
              }}
            >
              <Paginator
                currentPage={this.state.currentPage}
                totalPages={this.state.totalPages}
                onFirstPageClick={this.onFirstPageClick.bind(this)}
                onPreviousPageClick={this.onPreviousPageClick.bind(this)}
                onNextPageClick={this.onNextPageClick.bind(this)}
                onLastPageClick={this.onLastPageClick.bind(this)}
              />

              <div style={{ minHeight: "70px" }} />
            </div>
          )}

          {this.state.dataLoading && (
            <div
              style={{
                display: "flex",
                width: "100%",
                height: "100%",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <WhisperSpinner
                size={50}
                color="var(--brown1)"
                frontColor="var(--brown1)"
                backColor="var(--brown1)"
                loading={true}
              />
            </div>
          )}
        </div>

        <Modal
          show={this.state.ModalShow}
          size="md"
          animation={true}
          onHide={this.hideModal.bind(this)}
          centered
        >
          <div className="settingContainer" style={{ padding: "10px" }}>
            <div className="ModalTitleSM">
              {this.state.modalType === 0 ? "رویداد جدید" : "ویرایش رویداد"}
            </div>

            <div
              style={{
                display: "flex",
                flexDirection: "column",
                overflow: "auto",
                marginTop: "20px",
                padding: "5px",
                width: "100%",
              }}
            >
              <div className="settingItemContainer">
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    flex: "1",
                    alignItems: "center",
                  }}
                >
                  <div className="settingLabel">نام</div>
                  <Form.Control
                    maxLength="50"
                    className={
                      this.state.NameErrorText !== ""
                        ? "inputStyleForm inputError textAlignCenter"
                        : "inputStyleForm textAlignCenter"
                    }
                    placeholder="نام رویداد"
                    type="text"
                    name="NameValue"
                    onChange={this.textHandleChange.bind(this)}
                    value={this.state.NameValue}
                  />
                </div>
              </div>

              <div className="settingItemContainer">
                <div
                  className="settingLabel"
                  style={{
                    color: this.state.noLimit
                      ? "var(--gray3)"
                      : "var(--black1)",
                  }}
                >
                  شروع:
                </div>
                <DatePicker
                  // ref={this.datepicker1}
                  value={this.state.dateValue1}
                  inputClass="form-control inputStyleForm textAlignCenter"
                  calendar="persian"
                  locale="fa"
                  weekDays={["ش", "ی", "د", "س", "چ", "پ", "ج"]}
                  format="YYYY/MM/DD"
                  animation
                  className="rmdp-mobile bluee"
                  onChange={(valuee) => this.dateChange1(valuee)}
                  // minDate={moment().format("jYYYY/jMM/jDD")}
                  editable={false}
                  inputMode="none"
                  placeholder="شروع"
                />
              </div>
              <div className="settingItemContainer">
                <div
                  className="settingLabel"
                  style={{
                    color: this.state.noLimit
                      ? "var(--gray3)"
                      : "var(--black1)",
                  }}
                >
                  پایان:
                </div>
                <DatePicker
                  // ref={this.datepicker2}
                  value={this.state.dateValue2}
                  inputClass="form-control inputStyleForm textAlignCenter"
                  calendar="persian"
                  locale="fa"
                  weekDays={["ش", "ی", "د", "س", "چ", "پ", "ج"]}
                  format="YYYY/MM/DD"
                  animation
                  className="rmdp-mobile bluee"
                  onChange={(valuee) => this.dateChange2(valuee)}
                  minDate={this.state.dateValue1}
                  editable={false}
                  inputMode="none"
                  placeholder="پایان"
                />
              </div>

              <div className="settingItemContainer">
                <div className="settingLabel" style={{ whiteSpace: "noWrap" }}>
                  اعتبار
                </div>
                <NumericFormat
                  className={
                    this.state.CreditErrorText !== ""
                      ? "inputStyleForm inputError textAlignCenter form-control"
                      : "form-control inputStyleForm textAlignCenter"
                  }
                  // placeholder="مبلغ"
                  placeholder={this.state.priceUnit}
                  style={{ direction: "ltr", maxWidth: "120px" }}
                  type="text"
                  name="CreditValue"
                  value={this.state.CreditValue}
                  allowNegative={true}
                  displayType={"input"}
                  thousandSeparator={true}
                  isNumericString
                  onValueChange={(values) => {
                    this.setState({ CreditValue: values.value });
                  }}
                />
              </div>

              <div className="settingItemContainer">
                <div className="settingLabel" style={{ whiteSpace: "noWrap" }}>
                  وضعیت
                </div>
                <BootstrapSwitchButton
                  checked={this.state.IsActive}
                  onChange={(checked) => {
                    this.setState({ IsActive: checked });
                  }}
                  onlabel="فعال"
                  offlabel="غیرفعال"
                  onstyle="primary"
                  offstyle="warning"
                  width={100}
                />
              </div>

              <div className="settingItemContainer">
                <div className="settingLabel" style={{ whiteSpace: "noWrap" }}>
                  حداقل خرید
                </div>
                <NumericFormat
                  className={
                    this.state.MinPurchaseErrorText !== ""
                      ? "inputStyleForm inputError textAlignCenter form-control"
                      : "form-control inputStyleForm textAlignCenter"
                  }
                  // placeholder="مبلغ"
                  placeholder={this.state.priceUnit}
                  style={{ direction: "ltr", maxWidth: "120px" }}
                  type="text"
                  name="MinPurchaseValue"
                  value={this.state.MinPurchaseValue}
                  allowNegative={true}
                  displayType={"input"}
                  thousandSeparator={true}
                  isNumericString
                  onValueChange={(values) => {
                    this.setState({ MinPurchaseValue: values.value });
                  }}
                />
              </div>

              {/* <div
                className="settingItemContainer"
                style={{ fontSize: "14px", fontFamily: "SFUIDisplayBold" }}
              >
                <Form.Check
                  type="checkbox"
                  label="داخلی"
                  checked={this.state.insideCheck}
                  onChange={() =>
                    this.setState({ insideCheck: !this.state.insideCheck })
                  }
                />
                <Form.Check
                  type="checkbox"
                  label="بسته بندی"
                  checked={this.state.packCheck}
                  onChange={() =>
                    this.setState({ packCheck: !this.state.packCheck })
                  }
                />
                <Form.Check
                  type="checkbox"
                  label="ارسال"
                  checked={this.state.sendCheck}
                  onChange={() =>
                    this.setState({ sendCheck: !this.state.sendCheck })
                  }
                />
              </div> */}

              {this.state.messageList.length < 1 && (
                <div className="settingItemContainer">
                  <div style={{ flex: "1" }}>
                    <CustomButton
                      title="انتخاب الگوی پیام"
                      minHeight="35px"
                      onClick={this.onMessagePatternClick.bind(this)}
                    />
                  </div>
                </div>
              )}

              {this.state.messageList.length > 0 && (
                <div
                  className="settingItemContainer"
                  style={{ flexDirection: "column" }}
                >
                  <div style={{ flex: "1" }}>
                    {this.state.messageList[0].text}
                  </div>
                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      flexDirection: "row",
                      marginTop: "10px",
                    }}
                  >
                    <div style={{ width: "100%" }} />
                    <CustomButton
                      title="تغییر الگوی پیام"
                      minHeight="35px"
                      onClick={this.onMessagePatternClick.bind(this)}
                    />
                  </div>
                </div>
              )}

              <div className="settingItemContainer">
                <div className="settingLabel" style={{ whiteSpace: "noWrap" }}>
                  اعمال برای تمام مشترکین
                </div>
                <BootstrapSwitchButton
                  checked={this.state.forAllUsers}
                  onChange={(checked) =>
                    this.setState({
                      forAllUsers: checked,
                      forSomeUsers:
                        checked && this.state.forSomeUsers
                          ? false
                          : this.state.forSomeUsers,
                      roughlyCost: 0,
                      roughlyCostPressed: false,
                      totalAccountsCount: 0,
                    })
                  }
                  disabled={this.state.modalType !== 0}
                  onlabel="بله"
                  offlabel="خیر"
                  onstyle="primary"
                  offstyle="warning"
                  width={75}
                />
              </div>

              <div
                className="settingItemContainer"
                style={{ flexDirection: "column" }}
              >
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <div
                    className="settingLabel"
                    style={{ whiteSpace: "noWrap" }}
                  >
                    فیلتر مشترکین
                  </div>
                  <BootstrapSwitchButton
                    checked={this.state.forSomeUsers}
                    onChange={(checked) => {
                      this.setState({
                        forSomeUsers: checked,
                        forAllUsers:
                          checked && this.state.forAllUsers
                            ? false
                            : this.state.forAllUsers,
                        roughlyCost: 0,
                        roughlyCostPressed: false,
                        totalAccountsCount: 0,
                      });
                    }}
                    disabled={this.state.modalType !== 0}
                    onlabel="بله"
                    offlabel="خیر"
                    onstyle="primary"
                    offstyle="warning"
                    // disabled={this.state.forAllUsers}
                    width={75}
                  />
                </div>

                {this.state.forSomeUsers && (
                  <div
                    className="settingItemInside"
                    style={{ marginTop: "10px" }}
                  >
                    <div
                      className="settingLabel"
                      style={{
                        color: this.state.noLimit
                          ? "var(--gray3)"
                          : "var(--black1)",
                      }}
                    >
                      از تاریخ:
                    </div>
                    <DatePicker
                      // ref={this.datepicker3}
                      value={this.state.dateValue3}
                      inputClass="form-control inputStyleForm textAlignCenter"
                      calendar="persian"
                      locale="fa"
                      weekDays={["ش", "ی", "د", "س", "چ", "پ", "ج"]}
                      format="YYYY/MM/DD"
                      animation
                      className="rmdp-mobile bluee"
                      onChange={(valuee) => this.dateChange3(valuee)}
                      editable={false}
                      inputMode="none"
                      placeholder="از تاریخ"
                      disabled={this.state.modalType !== 0}
                    />
                  </div>
                )}
                {this.state.forSomeUsers && (
                  <div className="settingItemInside">
                    <div
                      className="settingLabel"
                      style={{
                        color: this.state.noLimit
                          ? "var(--gray3)"
                          : "var(--black1)",
                      }}
                    >
                      تا تاریخ:
                    </div>
                    <DatePicker
                      // ref={this.datepicker4}
                      value={this.state.dateValue4}
                      inputClass="form-control inputStyleForm textAlignCenter"
                      calendar="persian"
                      locale="fa"
                      weekDays={["ش", "ی", "د", "س", "چ", "پ", "ج"]}
                      format="YYYY/MM/DD"
                      animation
                      className="rmdp-mobile bluee"
                      onChange={(valuee) => this.dateChange4(valuee)}
                      minDate={this.state.dateValue3}
                      editable={false}
                      inputMode="none"
                      placeholder="تا تاریخ"
                      disabled={this.state.modalType !== 0}
                    />
                  </div>
                )}

                {this.state.forSomeUsers && (
                  <div className="settingItemInside">
                    <div
                      className="settingLabel"
                      style={{ whiteSpace: "noWrap" }}
                    >
                      خرید از
                    </div>
                    <NumericFormat
                      className={
                        this.state.fromPurchaseErrorText !== ""
                          ? "inputStyleForm inputError textAlignCenter form-control"
                          : "form-control inputStyleForm textAlignCenter"
                      }
                      // placeholder="مبلغ"
                      placeholder={this.state.priceUnit}
                      style={{ direction: "ltr", maxWidth: "120px" }}
                      type="text"
                      name="fromPurchaseValue"
                      value={this.state.fromPurchaseValue}
                      allowNegative={true}
                      displayType={"input"}
                      thousandSeparator={true}
                      isNumericString
                      onValueChange={(values) => {
                        this.setState({ fromPurchaseValue: values.value });
                      }}
                      disabled={this.state.modalType !== 0}
                    />
                  </div>
                )}

                {this.state.forSomeUsers && (
                  <div className="settingItemInside">
                    <div
                      className="settingLabel"
                      style={{ whiteSpace: "noWrap" }}
                    >
                      خرید تا
                    </div>
                    <NumericFormat
                      className={
                        this.state.toPurchaseErrorText !== ""
                          ? "inputStyleForm inputError textAlignCenter form-control"
                          : "form-control inputStyleForm textAlignCenter"
                      }
                      // placeholder="مبلغ"
                      placeholder={this.state.priceUnit}
                      style={{ direction: "ltr", maxWidth: "120px" }}
                      type="text"
                      name="toPurchaseValue"
                      value={this.state.toPurchaseValue}
                      allowNegative={true}
                      displayType={"input"}
                      thousandSeparator={true}
                      isNumericString
                      onValueChange={(values) => {
                        this.setState({ toPurchaseValue: values.value });
                      }}
                      disabled={this.state.modalType !== 0}
                    />
                  </div>
                )}
              </div>

              <div
                className="settingItemContainer"
                style={{ flexDirection: "column" }}
              >
                <div style={{ width: "100%" }}>
                  <CustomButton
                    title="انتخاب گروه مشترکین"
                    minHeight="35px"
                    onClick={this.onCustomerGroupsClick.bind(this)}
                    disabled={
                      this.state.forAllUsers ||
                      this.state.forSomeUsers ||
                      this.state.modalType !== 0
                        ? true
                        : false
                    }
                  />
                </div>

                {this.state.selectedGroupList.length > 0 && (
                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      flexDirection: "row",
                      flexWrap: "wrap",
                      marginTop: "10px",
                    }}
                  >
                    {this.state.selectedGroupList.map((item, i) => {
                      return this.state.groupList.map((item1, i1) => {
                        if (item === item1.id) {
                          return (
                            <div
                              style={{
                                padding: "5px",
                                backgroundColor: "var(--gray1)",
                                border: "1px solid var(--brown1)",
                                borderRadius: "4px",
                                margin: "5px",
                                textAlign: "center",
                                position: "relative",
                              }}
                            >
                              {item1.name}
                              <div
                                key={i}
                                style={{
                                  width: "15px",
                                  height: "15px",
                                  backgroundColor: "var(--brown1)",
                                  position: "absolute",
                                  right: "-8px",
                                  top: "-7px",
                                  borderRadius: "50%",
                                  textAlign: "center",
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  color: "white",
                                  fontSize: "10px",
                                  cursor: "pointer",
                                }}
                                onClick={() => {
                                  let list = JSON.parse(
                                    JSON.stringify(this.state.selectedGroupList)
                                  );
                                  let temp = list.filter((el) => el !== item);

                                  this.setState({
                                    selectedGroupList: temp,
                                  });
                                }}
                              >
                                &#10006;
                              </div>
                            </div>
                          );
                        } else return null;
                      });
                    })}
                  </div>
                )}
              </div>

              <div className="settingItemContainer">
                <div>
                  <CustomButton
                    title="محاسبه هزینه تقریبی"
                    minHeight="35px"
                    onClick={this.onCalCostClick.bind(this)}
                    whiteSpace="noWrap"
                    disabled={this.state.modalType !== 0}
                  />
                </div>
                <div style={{ minWidth: "20px" }} />
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "flex-start",
                    alignItems: "center",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between",
                      width: "100%",
                    }}
                  >
                    <div
                      className="settingLabel"
                      style={{ whiteSpace: "noWrap", marginLeft: "10px" }}
                    >
                      تعداد مشترکین:
                    </div>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                      }}
                    >
                      <NumericFormat
                        // style={{ direction: "ltr", maxWidth: "120px" }}
                        type="text"
                        name="MinPurchaseValue"
                        value={this.state.totalAccountsCount}
                        allowNegative={true}
                        displayType={"text"}
                        thousandSeparator={true}
                        isNumericString
                      />
                    </div>
                  </div>
                  <div style={{ minHeight: "10px" }} />
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between",
                      width: "100%",
                    }}
                  >
                    <div
                      className="settingLabel"
                      style={{ whiteSpace: "noWrap", marginLeft: "10px" }}
                    >
                      مبلغ:
                    </div>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                      }}
                    >
                      <NumericFormat
                        style={{ direction: "ltr", maxWidth: "120px" }}
                        type="text"
                        name="MinPurchaseValue"
                        value={this.state.roughlyCost}
                        allowNegative={true}
                        displayType={"text"}
                        thousandSeparator={true}
                        isNumericString
                      />
                      <div
                        className="settingLabel"
                        style={{
                          whiteSpace: "noWrap",
                          marginRight: "10px",
                          marginLeft: "0px",
                        }}
                      >
                        {this.state.priceUnit}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div
              style={{
                width: "100%",
                maxWidth: "500px",
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                marginTop: "20px",
                alignItems: "center",
              }}
            >
              <div style={{ flex: "1" }}>
                <CustomButton
                  title="ذخیره"
                  loading={this.state.writingProgress}
                  imgHeight={20}
                  imgWidth={25}
                  minHeight="35px"
                  img={Tick}
                  onClick={this.onConfirm.bind(this)}
                />
              </div>
              <div style={{ minWidth: "10px" }} />
              <div style={{ flex: "0.8" }}>
                <CustomButton
                  title="انصراف"
                  imgHeight={19}
                  backColor="var(--black1)"
                  imgWidth={25}
                  minHeight="35px"
                  img={Cancel}
                  onClick={this.hideModal.bind(this)}
                />
              </div>
            </div>
          </div>
        </Modal>

        <Modal
          show={this.state.ModalShow2}
          animation={true}
          size="md"
          backdrop="static"
          backdropClassName="backdropClassName"
          onHide={this.hideModal2.bind(this)}
          centered
        >
          {this.state.ModalShow2 && (
            <ListViewer
              groups={this.state.currentListType === "group"}
              listType={this.state.currentListType}
              currentSelected={
                this.state.currentListType === "group"
                  ? this.state.selectedGroupList
                  : this.state.selectedMessageList
              }
              list={
                this.state.currentListType === "group"
                  ? this.state.groupList
                  : this.state.messageList
              }
              loading={this.state.listLoading}
              // onConfirmCategory={this.onConfirmCategory.bind(this)}
              onConfirmGroups={this.onConfirmGroups.bind(this)}
              onConfirmMessage={this.onConfirmMessage.bind(this)}
              hideModal={this.hideModal2.bind(this)}
            />
          )}
        </Modal>

        <Modal
          show={this.state.ModalReport}
          animation={true}
          // size="lg"
          contentClassName="contanetStyleModal"
          onHide={() => this.setState({ ModalReport: false })}
          centered
        >
          {this.state.modalReportLoading && (
            <div
              style={{
                display: "flex",
                width: "90vw",
                maxWidth: "1200px",
                height: "75vh",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <WhisperSpinner
                size={50}
                color="var(--brown1)"
                frontColor="var(--brown1)"
                backColor="var(--brown1)"
                loading={true}
              />
            </div>
          )}
          {!this.state.modalReportLoading && (
            <div className="RestaurantsListTitle">گزارش رویداد</div>
          )}

          {!this.state.modalReportLoading && (
            <div
              className="pageContents"
              style={{ width: "90vw", height: "auto", alignItems: "center" }}
              // ref={this.chartContainer}
            >
              با توجه به زمان ارسال پيام ها و دريافت فاکتور ها از شعب، اين گزارش
              حداقل 12 ساعت بعد از تاريخ پايان رويداد معتبر می باشد
              <div className="smsInfoTable">
                <div className="smsInfoTableCell">
                  {this.state.currentEventName}
                </div>
                <div className="smsInfoTableCell">
                  {this.state.currentEventStartDate}&nbsp;تا&nbsp;{" "}
                  {this.state.currentEventEndDate}
                </div>
                <div className="smsInfoTableCell" style={{ border: "0px" }}>
                  {this.state.currentEventText}
                </div>
              </div>
              <div className="reportExtraInfoMainContainer">
                <div className="reportExtraInfoContainer">
                  <div className="singleInfo" style={{ marginTop: "20px" }}>
                    <div style={{ marginLeft: "10px", marginBottom: "10px" }}>
                      تعداد پيام های ارسالی:{" "}
                    </div>
                    <NumericFormat
                      className="singleInfoNumberValue"
                      value={this.state.reportTotalSMSCount}
                      displayType={"text"}
                      thousandSeparator={true}
                      suffix={" عدد"}
                    />
                  </div>
                  <div className="singleInfo" style={{ marginTop: "20px" }}>
                    <div style={{ marginLeft: "10px", marginBottom: "10px" }}>
                      اعتبار فعلی:{" "}
                    </div>
                    <NumericFormat
                      className="singleInfoNumberValue"
                      value={this.state.reportSMSCost}
                      displayType={"text"}
                      thousandSeparator={true}
                      suffix={" " + this.state.priceUnit}
                    />
                  </div>

                  <div className="singleInfo" style={{ marginTop: "20px" }}>
                    <div
                      style={{
                        marginLeft: "10px",
                        marginBottom: "10px",
                        display: "flex",
                        flexDirection: "row-reverse",
                      }}
                    >
                      <div>&nbsp;هزينه پيام&nbsp;</div>
                      <div>-</div>
                      <div>&nbsp;هزينه فاکتور&nbsp;</div>
                      <div>=</div>
                      <div>&nbsp;هزينه رويداد&nbsp;</div>
                    </div>

                    <div
                      style={{
                        marginLeft: "10px",
                        marginBottom: "10px",
                        display: "flex",
                        flexDirection: "row-reverse",
                      }}
                    >
                      <div>&nbsp;{this.state.reportSMSCost}&nbsp;</div>
                      <div>-</div>
                      <div>
                        &nbsp;{this.state.reportTotalInvoicePrice}&nbsp;
                      </div>
                      <div>=</div>
                      <div>
                        &nbsp;
                        {this.state.reportSMSCost -
                          this.state.reportTotalInvoicePrice}
                        &nbsp;
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="smsReportChartContainer"
                ref={this.chartContainer}
              >
                <div
                  style={{
                    flex: "1",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                >
                  <div
                    style={{
                      height: "200px",
                      width: "200px",
                    }}
                  >
                    <CircularProgressbar
                      strokeWidth={15}
                      value={this.state.smsReportPercent}
                      text={`${this.state.smsReportPercent}%`}
                      styles={buildStyles({
                        textSize: "16px",
                        pathTransitionDuration: 2,
                        pathColor: "#d6783a",
                        textColor: "#d6783a",
                        trailColor: "#58341d",
                      })}
                    />
                  </div>

                  <div
                    className="circularProgressContainerTitle"
                    style={{ color: "var(--brown1)" }}
                  >
                    درصد مشارکت
                  </div>
                </div>

                {/* <div style={{ flex: "1" }}>
                  <PieChart
                    rtlEnabled
                    id="pie"
                    palette={["var(--brown1)", "#58341d"]}
                    dataSource={this.state.chartData}
                    ref={this.chartRef}
                  >
                    <Legend
                      orientation="horizontal"
                      itemTextPosition="left"
                      horizontalAlignment="center"
                      columnCount={1}
                      verticalAlignment="bottom"
                    >
                      <Font color="var(--brown1)" family="SFUIDisplay" />
                    </Legend>
                    <Series argumentField="title" valueField="value">
                      <Label
                        visible={true}
                        backgroundColor="var(--brown1)"
                        // customizeText={this.creditValue}
                        wordWrap="none"
                        textOverflow="none"
                      >
                        <Connector
                          visible={true}
                          width={1}
                          color="var(--brown1)"
                        />
                        <Font color="white" family="SFUIDisplay" size={14} />
                      </Label>
                      <SmallValuesGrouping
                        topCount={10}
                        mode="topN"
                        groupName="سایر"
                      />
                    </Series>

                    <Size
                      height={350}
                      width={
                        this.state.thisWidth > 400
                          ? 350
                          : this.state.thisWidth * 0.9
                      }
                    />
                  </PieChart>
                </div> */}
              </div>
              <div
                style={{
                  width: "100%",
                  maxWidth: "250px",
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  marginTop: "40px",
                  alignItems: "center",
                }}
              >
                <div style={{ flex: "1" }}>
                  <CustomButton
                    title="بستن"
                    imgHeight={19}
                    backColor="var(--black1)"
                    imgWidth={25}
                    minHeight="35px"
                    img={Cancel}
                    onClick={() => this.setState({ ModalReport: false })}
                  />
                </div>
              </div>
            </div>
          )}
        </Modal>

        <Modal
          show={this.state.DeleteModalShow}
          size="md"
          animation={true}
          onHide={() => this.setState({ DeleteModalShow: false })}
          centered
        >
          <div className="dialogBox">
            آیا از حذف رویداد مورد نظر از لیست اطمینان دارید؟
            <div
              style={{
                width: "100%",
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                marginTop: "20px",
                alignItems: "center",
              }}
            >
              <div style={{ flex: "1" }}>
                <CustomButton
                  title="بله"
                  loading={this.state.deleteConfirmLoading}
                  imgHeight={20}
                  imgWidth={25}
                  minHeight="35px"
                  img={Tick}
                  onClick={this.onConfirmDelete.bind(this)}
                />
              </div>
              <div style={{ minWidth: "5px" }} />
              <div style={{ flex: "0.8" }}>
                <CustomButton
                  title="خیر"
                  imgHeight={19}
                  backColor="var(--black1)"
                  imgWidth={25}
                  minHeight="35px"
                  img={Cancel}
                  onClick={() => this.setState({ DeleteModalShow: false })}
                />
              </div>
            </div>
          </div>
        </Modal>

        <Modal
          show={this.state.ActiveModalShow}
          size="md"
          animation={true}
          onHide={() => this.setState({ ActiveModalShow: false })}
          centered
        >
          <div
            className="settingContainer"
            style={{ padding: "10px", minHeight: "100px" }}
          >
            <div className="ModalTitleSM">فعال سازی نهایی رویداد</div>

            <div
              style={{
                display: "flex",
                flexDirection: "column",
                overflow: "auto",
                marginTop: "20px",
                padding: "5px",
                width: "100%",
              }}
            >
              <div className="settingItemContainer">
                <div
                  className="settingLabel"
                  style={{
                    color: this.state.noLimit
                      ? "var(--gray3)"
                      : "var(--black1)",
                    whiteSpace: "noWrap",
                  }}
                >
                  تاریخ ارسال:
                </div>
                <DatePicker
                  value={this.state.dateValue5}
                  inputClass="form-control inputStyleForm textAlignCenter"
                  calendar="persian"
                  locale="fa"
                  weekDays={["ش", "ی", "د", "س", "چ", "پ", "ج"]}
                  format="YYYY/MM/DD"
                  animation
                  className="rmdp-mobile bluee"
                  onChange={(valuee) => this.dateChange5(valuee)}
                  minDate={moment().format("jYYYY/jMM/jDD")}
                  editable={false}
                  inputMode="none"
                  placeholder="تاریخ ارسال"
                />
              </div>
            </div>

            <div
              style={{
                width: "100%",
                maxWidth: "500px",
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                marginTop: "20px",
                alignItems: "center",
              }}
            >
              <div style={{ flex: "1" }}>
                <CustomButton
                  title="فعال سازی نهایی"
                  loading={this.state.writingProgress}
                  imgHeight={20}
                  imgWidth={25}
                  minHeight="35px"
                  img={Tick}
                  onClick={this.onConfirmFinalActive.bind(this)}
                />
              </div>
              <div style={{ minWidth: "10px" }} />
              <div style={{ flex: "0.8" }}>
                <CustomButton
                  title="انصراف"
                  imgHeight={19}
                  backColor="var(--black1)"
                  imgWidth={25}
                  minHeight="35px"
                  img={Cancel}
                  onClick={() => this.setState({ ActiveModalShow: false })}
                />
              </div>
            </div>
          </div>
        </Modal>
        {/* <ReactTooltip effect="solid" /> */}
      </div>
    );
  }
}
